import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';

import { AdminService } from './admin.service';
import { AdminComponent } from './admin.component';
import { AdminRoutingModule } from './admin.routing.module';
import { AddressComponent } from './address/address.component';
import { UserRolesComponent } from './user-roles/user-roles.component';
import { ReasonsComponent } from './reasons/reasons.component';
import { YearCycleComponent } from './year-cycle/year-cycle.component';
import { YearComponent } from './year/year.component';

import { ReasonViolationComponent } from './reason-violation/reason-violation.component';
import { AuthenticationGuard } from '../authentication/authentication.guard';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AdminRoutingModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTabsModule,
        MatDialogModule,
        SharedModule,
    ],
    providers: [AdminService, AuthenticationGuard],
    exports: [],
    declarations: [AdminComponent, AddressComponent, UserRolesComponent, ReasonsComponent, ReasonViolationComponent, YearCycleComponent, YearComponent]
})
export class AdminModule { }
